export function setValue(key: string, value: string) {
  return window.localStorage.setItem(key, value);
}
export function getValue(key: string) {
  return window.localStorage.getItem(key);
}

export function deleteValue(key: string) {
  return window.localStorage.removeItem(key);
}
